module.exports = __webpack_public_path__ + "static/media/chat.dcb68032.svg";